''
<template>
  <div>
    <div>
      <div class="card-header">
        <div class="row">
          <div class="col-md-11">
            <h4>Reporte para facturacion</h4>
            <p>Reporte para facturación RIPS</p>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <form
          @submit.prevent="
            obtenerInformacionFacturacion(fechaInicial, fechaFinal, pacienteSelected)
          "
        >
          <div class="col-md-3">
            <label for="fechaInicial">Fecha inicial:</label>
            <input
              type="date"
              v-model="fechaInicial"
              required
              id="fechaInicial"
              class="form-control"
            />
          </div>
          <div class="col-md-3">
            <label for="fechaInicial">Fecha final:</label>
            <input
              type="date"
              v-model="fechaFinal"
              required
              id="fechaInicial"
              class="form-control"
            />
          </div>
          <div class="col-md-3">
            <label for="">Selecciona el paciente</label>
          <select
            name=""
            class="form-control"
            v-model="pacienteSelected"
            placeholder="Selecciona el paciente..."
          >
            <option value="todos" selected>Todos los pacientes</option>
            
            <option
              v-for="paciente in pacientes"
              :key="paciente.PacIdeUsu"
              :value="paciente.PacIdeUsu"
            >
              {{ paciente.PacNom1 + " " + paciente.PacApe1 }}
            </option>
          </select>
          </div>
          <div class="col-md-3">
            <br />
            <input
              type="submit"
              value="Buscar información"
              class="btn btn-success btn-fill"
            />
          </div>
        </form>
      </div>
      <div class="card" style="margin-top: 15px">
        <div class="row">
          <center>
            <div class="col-md-12" v-if="queriedData2 == ''">
              <center>
                <img
                  src="/static/img/ICONOS/estadisticas.svg"
                  alt="Imagen de datos vacios"
                  width="70"
                />
                <p class="titulo-mensaje">Aún no hay datos para mostrar.</p>
              </center>
            </div>
          </center>
        </div>

        <div class="row" style="padding-left: 30px" v-if="queriedData2 != ''">
          <br />
          <br />
          <div class="col-3">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <br />
            <br />
          </div>
        </div>

        <div
          class="row"
          ref="component"
          v-if="queriedData2 != ''"
          style="padding: 20px"
        >
          <div class="col-md-12">
            <download-excel
              class="btn btn-secondary btn-fill mb-2"
              :data="json_data"
              :fields="json_fields"
              worksheet="Copagos recibidos"
              :name="`reporte para facturacion ${fechaInicial} -- ${fechaFinal}`"
              v-if="json_data != ''"
            >
              Exportar a excel <i color="black" class="fa fa-download"></i>
            </download-excel>
            <br />
          </div>

          <div class="col-md-12" style="padding: 20px">
            <br />
            <div>
              <el-table border :data="queriedData" style="width: 100%">
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  height="500"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div class="row" v-if="queriedData2 != ''" style="padding: 25px">
          <div class="col-sm-6 pagination-info">
            <br />
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axiosInstance from "src/global-services/axiosInstance";
import axios from "axios";
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import JsonExcel from "vue-json-excel";
import crearAlerta from "../../global-services/crearAlerta";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.component("downloadExcel", JsonExcel);

export default {
  computed: {
    pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      let result = this.queriedData2.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    },
  },
  components: {
    PPagination,
  },
  data: () => ({
    ip: "https://avanti-erp.com/",
    fechaInicial: "",
    fechaFinal: "",
    pacientes: [],
    pacienteSelected: "todos",
    queriedData2: [],
    tableColumns: [
      {
        prop: "TipoDeDoc",
        label: "Tipo deDoc",
        minWidth: 100,
      },
      {
        prop: "Prefijo",
        label: "Prefijo",
        minWidth: 100,
      },
      {
        prop: "CodigoFac",
        label: "Numero Factura",
        minWidth: 100,
      },
      {
        prop: "NombrePaciente",
        label: "Nombre del paciente",
        minWidth: 180,
      },
      {
        prop: "CodInventario",
        label: "Cod Inventario",
        minWidth: 100,
      },
      {
        prop: "IdPaciente",
        label: "Id Paciente",
        minWidth: 100,
      },
      {
        prop: "CodPrestador",
        label: "Cod Prestador",
        minWidth: 100,
      },
      {
        prop: "FechaInicioAtencion",
        label: "Fecha inicio atencion",
        minWidth: 200,
      },
      {
        prop: "NumAutorizacion",
        label: "Num. Autorizacion",
        minWidth: 100,
      },
      {
        prop: "Cups",
        label: "Cups",
        minWidth: 100,
      },
      {
        prop: "ModalidadAtencion",
        label: "Modalidad de atencion",
        minWidth: 100,
      },
      {
        prop: "CodGrupoServicio",
        label: "Cod. Grupo servicio",
        minWidth: 100,
      },
      {
        prop: "CodServicio",
        label: "Cod. Servicio",
        minWidth: 100,
      },
      {
        prop: "CodFinalidad",
        label: "Cod. Finalidad",
        minWidth: 100,
      },
      {
        prop: "CodMotivoAtencion",
        label: "Cod. Motivo de Atencion",
        minWidth: 100,
      },
      {
        prop: "Dx",
        label: "Diagnostico",
        minWidth: 100,
      },
      {
        prop: "CodTipoDiagnostico",
        label: "Cod. Tipo Diagnostico",
        minWidth: 100,
      },
      {
        prop: "TipoDocumentoIdentificacionTerapeuta",
        label: "Tipo Identificacion",
        minWidth: 100,
      },
      {
        prop: "NumIdentificacionTerapeuta",
        label: "Num. Identificacion",
        minWidth: 100,
      },
      {
        prop: "VrServicio",
        label: "Vr Servicio",
        minWidth: 100,
      },
      {
        prop: "ConceptoRecaudo",
        label: "Concepto recaudo",
        minWidth: 100,
      },
      {
        prop: "ValorPagoModerador",
        label: "Valor pago moderador",
        minWidth: 100,
      },
      {
        prop: "NumFev",
        label: "NumFEVPagoMode",
        minWidth: 100,
      },
      {
        prop: "CodigoVida",
        label: "codigoVIDA",
        minWidth: 100,
      },
    ],
    pagination: {
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
    json_fields: {
      "Tipo deDoc": "TipoDeDoc",
      Prefijo: "Prefijo",
      "Numero Factura": "CodigoFac",
      "Cod Inventario": "CodInventario",
      "Nombre del paciente" : "NombrePaciente",
      "ID paciente": "IdPaciente",
      CodPrestador: "CodPrestador",
      FechaInicioAtencion: "FechaInicioAtencion",
      NumAutorizacion: "NumAutorizacion",
      CUPS: "Cups",
      Cod_ModalidadAtencion: "ModalidadAtencion",
      Cod_GrupoServicio: "CodGrupoServicio",
      Cod_Servicio: "CodServicio",
      Cod_Finalidad: "CodFinalidad",
      Cod_MotivoAtencion: "CodMotivoAtencion",
      "codDiagnosticoPrincipalCIE11": "codDiagnosticoPrincipalCIE11",
      "nomCodDiagnosticoPrincipalCIE11": "nomCodDiagnosticoPrincipalCIE11",
      "Cod DiagnosticoRelacionado1": "CodDiagnosticoRelacionado1",
      codDiagnosticoRelacionado1CIE11: "codDiagnosticoRelacionado1CIE11",
      nomCodDiagnosticoRelacionado1CIE11: "nomCodDiagnosticoRelacionado1CIE11",
      "Cod DiagnosticoRelacionado2": "CodDiagnosticoRelacionado2",
      codDiagnosticoRelacionado2CIE11: "codDiagnosticoRelacionado2CIE11",
      nomCodDiagnosticoRelacionado2CIE11: "nomCodDiagnosticoRelacionado2CIE11",
      "Cod DiagnosticoRelacionado3": "CodDiagnosticoRelacionado3",
      codDiagnosticoRelacionado3CIE11: "codDiagnosticoRelacionado3CIE11",
      nomCodDiagnosticoRelacionado3CIE11: "nomCodDiagnosticoRelacionado3CIE11",
      Cod_TipoDiagnostico: "CodTipoDiagnostico",
      TipoDocumentoIdentificacion: "TipoDocumentoIdentificacionTerapeuta",
      NumDocumentoIdentificacion: "NumIdentificacionTerapeuta",
      VrServicio: "VrServicio",
      ConceptoRecaudo: "ConceptoRecaudo",
      ValorPagoModerador: "ValorPagoModerador",
      NumFEVPagoMode: "NumFev",
      codigoVIDA: "CodigoVida",
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
  }),
  methods: {
    async obtenerInformacionFacturacion(fechaInicial, fechaFinal, paciente) {
      try {
        this.$modal.show("carga");
        const response = await axiosInstance.get(
          `api/obtener-reporte-facturacion/${fechaInicial}/${fechaFinal}/${paciente}`,
        );
        this.expandirSesiones(response.data.data);
      } catch (error) {
        console.log("Error al obtener los datos:" + error);
      } finally {
        this.$modal.hide("carga");
      }
    },
    toMinutos(hhmmss) {
      const [h, m, s] = hhmmss.split(":").map(Number);
      return h * 60 + m + (s || 0) / 60;
    },

    minutosAHHMM(totalMinutos) {
      const h = Math.floor(totalMinutos / 60);
      const m = Math.round(totalMinutos % 60);
      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    },

    comoTexto(valor) {
    return `="${valor}"`;
  },

    expandirSesiones(data) {
      const resultado = [];

      data.forEach((row) => {
        const {
          ProFec,
          hora,
          horaFin,
          ProCanSes,
          terapeuta,
          PacNumDoc,
          ProEst,
          cedula,
          PacDia,
          PacNom1,
          PacApe1
        } = row;

        let codigo = '';
        if(PacDia){
            codigo = PacDia.trim().split('-')[0];
        }

        const inicioMin = this.toMinutos(hora);
        const finMin = this.toMinutos(horaFin);
        const duracionTotal = finMin - inicioMin;
        const duracionSesion =
          ProCanSes > 0 ? duracionTotal / ProCanSes : duracionTotal;

        for (let i = 0; i < ProCanSes; i++) {
          const inicioSesion = inicioMin + i * duracionSesion;
          const finSesion = inicioSesion + duracionSesion;

          const horaInicioStr = this.minutosAHHMM(inicioSesion);
          const horaFinStr = this.minutosAHHMM(finSesion);

          resultado.push({
            TipoDeDoc: "FV",
            Prefijo: "CR",
            CodigoFac: "",
            CodInventario: "",
            NombrePaciente: `${PacNom1} ${PacApe1}`,
            IdPaciente: PacNumDoc,
            CodPrestador: "080010311201",
            FechaInicioAtencion: `${ProFec} ${horaInicioStr}`,
            NumAutorizacion: "",
            Cups: "",
            ModalidadAtencion: "01",
            CodGrupoServicio: "02",
            CodServicio: "",
            CodFinalidad: "17",
            CodMotivoAtencion: "38",
            Dx: codigo,
            codDiagnosticoPrincipalCIE11: '',
            nomCodDiagnosticoPrincipalCIE11: '',
            CodDiagnosticoRelacionado1: '',
            codDiagnosticoRelacionado1CIE11: '',
            nomCodDiagnosticoRelacionado1CIE11: '',
            CodDiagnosticoRelacionado2: '',
            codDiagnosticoRelacionado2CIE11: '',
            nomCodDiagnosticoRelacionado2CIE11: '',
            codDiagnosticoRelacionado3CIE11: '',
            nomCodDiagnosticoRelacionado3CIE11: '',
            CodDiagnosticoRelacionado3: '',
            CodTipoDiagnostico: "01",
            TipoDocumentoIdentificacionTerapeuta: "CC",
            NumIdentificacionTerapeuta: cedula,
            VrServicio: "",
            ConceptoRecaudo: "05",
            ValorPagoModerador: "",
            NumFev: "",
            CodigoVida: "",
          });
        }
      });
      this.queriedData2 = resultado;

      // Copia especial para exportar, forzando texto en los campos
      // que tienen ceros a la izquierda que se deben conservar
      const camposComoTexto = [
        "CodPrestador",
        "ModalidadAtencion",
        "CodGrupoServicio",
        "CodFinalidad",
        "CodMotivoAtencion",
        "CodTipoDiagnostico",
        "ConceptoRecaudo",
      ];



      this.json_data = resultado.map((fila) => {
        const filaExportacion = { ...fila };
        camposComoTexto.forEach((campo) => {
          if (filaExportacion[campo] !== "") {
            filaExportacion[campo] = this.comoTexto(filaExportacion[campo]);
          }
        });
        return filaExportacion;
      });
      
    },
    selectPaciente: function () {
      this.$modal.show("carga");
      const BASE_URL = `${this.ip}api/pacientesSelect`;
      axios
        .get(BASE_URL)
        .then((res) => {
          this.pacientes = res.data.data;
          this.$modal.hide("carga");
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },
  },
  mounted() {
    this.selectPaciente();
  },
};
</script>
<style scoped>
.table-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Reportes/reporteFacturacion.vue